import { takeEvery, put, call } from 'redux-saga/effects';

import * as actions from '../actions/contractProviders';
import * as API from '../api/contractProviders';
import { sessionErrorHandling } from './session';

function* create(action) {
    try {
        
        yield put({ type: actions.PROVIDERS_CREATE_PENDING });
        const {
            data,
            callback,
        } = action.payload;

        const newContract = yield call(API.createProvider, data);
        yield put({ type: actions.PROVIDERS_CREATE_FULFILLED, newContract });

        if (callback) {
            callback(true);
        }
    } catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.PROVIDERS_CREATE_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* get(action) {
    try {
        yield put({ type: actions.PROVIDERS_GET_PENDING });
        const { providerId } = action.payload;
        const payload = yield call(API.getProvider, providerId);
        yield put({ type: actions.PROVIDERS_GET_FULFILLED, payload });
    } catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.PROVIDERS_GET_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* update(action) {
    try {
        yield put({ type: actions.PROVIDER_UPDATE_PENDING });
        const {
            data,
            callback
        } = action.payload;

        yield call(API.updateProvider, data);
        yield put({ type: actions.PROVIDER_UPDATE_FULFILLED });

        if (callback) {
            callback(true);
        }
    } catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.PROVIDER_UPDATE_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* deleteProvider(action) {
    try {
        yield put({ type: actions.DELETE_PROVIDER_PENDING });
        const { providerId, callback } = action.payload;
        const payload = yield call(API.deleteProvider, providerId);
        yield put({ type: actions.DELETE_PROVIDER_FULFILLED, payload });
        if (callback) {
            callback(true);
        }
    } catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.DELETE_PROVIDER_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* download(action) {
    try {
        const { payload, callback } = action.payload;
        yield put({ type: actions.PROVIDER_DOWNLOAD_REPORT_PENDING });
        const response = yield call(API.downloadReport, payload);
        yield put({ type: actions.PROVIDER_DOWNLOAD_REPORT_FULFILLED });

        if (callback) {
            callback(response);
        }
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.PROVIDER_DOWNLOAD_REPORT_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* uploadFile(action) {
    try {
        const { callback, csvData } = action.payload;
        yield put({ type: actions.PROVIDER_UPLOAD_FILE_PENDING });
        const payload = yield call(API.importProviders, csvData );
        yield put({ type: actions.PROVIDER_UPLOAD_FILE_FULFILLED });
        if (callback) {
            callback(payload);
        }
    }
    catch (error) {
        const { error: errorMessage, innerException, errorDetails } = (error && error.payload) || { error: '', errorDetails: '', innerException: '' };
        yield put({ type: actions.PROVIDER_UPLOAD_FILE_REJECTED, payload: { errorMessage, innerException, errorDetails } });
        yield call(sessionErrorHandling, error);
    }
}

function* updateStatus(action) {
    try {
        yield put({ type: actions.PROVIDER_STATUS_UPDATE_PENDING });
        const {
            payload,
            isCriteria,
            enable,
            callback,
        } = action.payload;
        if(isCriteria) {
            yield call(API.updateStatusByCriteria, payload, enable);
        }
        else {
            yield call(API.updateStatus, payload);
        }
        yield put({ type: actions.PROVIDER_STATUS_UPDATE_FULFILLED });
        if (callback) {
            callback();
        }
    } catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.PROVIDER_STATUS_UPDATE_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* searchFromNPI(action) {
    try {
        yield put({ type: actions.PROVIDER_SEARCH_FROM_NPI_PENDING });
        const { npi, callback } = action.payload;
        const payload = yield call(API.searchFromNPIRegistry, npi);
        yield put({ type: actions.PROVIDER_SEARCH_FROM_NPI_FULFILLED, payload });
        if (callback) {
            callback(payload);
        }
    } catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.PROVIDER_SEARCH_FROM_NPI_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* updateProviderNPIRole(action) {
    try {
        yield put({ type: actions.PROVIDER_UPDATE_NPI_ROLE_PENDING });
        const {
            data,
            callback
        } = action.payload;

        yield call(API.updateProviderNPIRole, data);
        yield put({ type: actions.PROVIDER_UPDATE_NPI_ROLE_FULFILLED });

        if (callback) {
            callback(true);
        }
    } catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.PROVIDER_UPDATE_NPI_ROLE_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

export default function* () {
    yield takeEvery(actions.PROVIDERS_CREATE, create);
    yield takeEvery(actions.PROVIDERS_GET, get);
    yield takeEvery(actions.PROVIDER_UPDATE, update);
    yield takeEvery(actions.DELETE_PROVIDER, deleteProvider);
    yield takeEvery(actions.PROVIDER_DOWNLOAD_REPORT, download);
    yield takeEvery(actions.PROVIDER_UPLOAD_FILE, uploadFile);
    yield takeEvery(actions.PROVIDER_STATUS_UPDATE, updateStatus);
    yield takeEvery(actions.PROVIDER_SEARCH_FROM_NPI, searchFromNPI);
    yield takeEvery(actions.PROVIDER_UPDATE_NPI_ROLE, updateProviderNPIRole);
}